module.exports = __webpack_public_path__ + "img/back-yanqijiaofu.cc3d1f05.png";